// DENSO Promoter Training Manual content — 5 sequential modules matching the
// topics in the client-supplied "DENSO Q&A.docx" document. Each module has
// its own Q&A quiz (fetched from the backend) that requires a 100% score to
// unlock the next module.

export const SPARK_PLUG_VIDEO_1_URL =
  "https://customer-assets-jt897jd0.emergentagent.net/job_denso-cert-academy/artifacts/294262b6affa4eba_Danso%20Spark%20Plug%20Module%201.mp4";
export const SPARK_PLUG_VIDEO_2_URL =
  "https://customer-assets-jt897jd0.emergentagent.net/job_denso-cert-academy/artifacts/9343346edfc4c530_Danso%20Spark%20Plugs%20Module%202%20%281%29.mp4";
export const AIR_AND_OIL_FILTERS_VIDEO_URL =
  "https://customer-assets-jt897jd0.emergentagent.net/job_denso-cert-academy/artifacts/0t4tppod_Air%20and%20Oil%20Filters%20Module.mp4";
export const SERVICE_AND_FILTER_KITS_VIDEO_URL =
  "https://customer-assets-jt897jd0.emergentagent.net/job_denso-cert-academy/artifacts/jfif5xpp_Service%20and%20filter%20kits%20module%20.mp4";
export const WIPER_BLADES_VIDEO_URL =
  "https://customer-assets-jt897jd0.emergentagent.net/job_denso-cert-academy/artifacts/5c12c9926f4e70db_Wiper%20Blades%20Module%20Final%20%281%29.mp4";
export const CABIN_AIR_FILTER_VIDEO_URL =
  "https://customer-assets-jt897jd0.emergentagent.net/job_denso-cert-academy/artifacts/hteapg5q_Cabin%20Air%20Filter%20Module.mp4";

export const TRAINING_MODULES = [
  {
    id: "module-1",
    order: 1,
    title: "Spark Plugs",
    subtitle: "DENSO TT, Direct Fit and Iridium TT technology",
    videoUrls: [SPARK_PLUG_VIDEO_1_URL, SPARK_PLUG_VIDEO_2_URL],
    keyPoints: [
      "DENSO TT combines broader application coverage, improved combustion performance and three customer choice levels: Nickel TT, Platinum TT and Iridium TT.",
      "Iridium TT is the premium TT option, offering high performance and durability of up to 100,000 km under suitable operating conditions.",
      "Direct Fit follows the specific OE-style replacement requirements of the vehicle application, while TT uses Twin Tip technology with broader application coverage.",
      "Direct Fit is ideal for the customer who wants the correct application-specific replacement, while TT suits customers looking for Twin Tip technology benefits.",
    ],
  },
  {
    id: "module-2",
    order: 2,
    title: "Oil & Air Filter",
    subtitle: "Clean air, clean oil and reliable engine protection",
    videoUrls: [AIR_AND_OIL_FILTERS_VIDEO_URL],
    keyPoints: [
      "A DENSO air filter removes dust and foreign particles from the air entering the engine, supporting clean airflow and reliable engine performance.",
      "A quality DENSO oil filter removes contaminants from the engine oil, supporting proper lubrication and protecting critical engine components.",
      "Key sales message: Clean air. Clean oil. Engine protection. Reliable performance.",
      "Before selling: identify the vehicle make, model, year and engine details, then use the latest DENSO Catalogue to confirm the correct filter type, dimensions and application.",
    ],
  },
  {
    id: "module-3",
    order: 3,
    title: "Cabin Air Filter",
    subtitle: "Cleaner air and reliable cabin ventilation",
    videoUrls: [CABIN_AIR_FILTER_VIDEO_URL],
    keyPoints: [
      "A DENSO cabin air filter helps filter dust, pollen and airborne particles entering the cabin, giving cleaner, fresher air for driver and passengers.",
      "It helps maintain reliable ventilation and HVAC system performance for the whole cabin.",
      "Key sales message: Cleaner air. Better cabin comfort. Reliable ventilation.",
      "Strongest selling points: OE manufacturer quality, cost effective routine replacement, and cleaner cabin air with improved passenger comfort.",
    ],
  },
  {
    id: "module-4",
    order: 4,
    title: "Service & Filter Kit",
    subtitle: "Everything needed for a complete service, in one box",
    videoUrls: [SERVICE_AND_FILTER_KITS_VIDEO_URL],
    keyPoints: [
      "The DENSO Service Kit is the more complete service solution and can include spark plugs for petrol applications.",
      "The DENSO Filter Kit provides a lower cost, filter-only solution — choose based on the customer's servicing needs and budget.",
      "For a full vehicle service, recommend the Service Kit first because it provides the more complete package for the applicable vehicle.",
      "Before selling: confirm the vehicle details, use the latest DENSO Catalogue to identify the correct kit, and confirm the part number and included components.",
    ],
  },
  {
    id: "module-5",
    order: 5,
    title: "Wiper Blades",
    subtitle: "Clear visibility with DENSO Design and Conventional blades",
    videoUrls: [WIPER_BLADES_VIDEO_URL],
    keyPoints: [
      "DENSO wiper blades give clearer visibility in changing weather — selected ranges use graphite coated rubber for smoother wiping and OE manufacturer quality.",
      "Design Blades provide a sleek OE-style flat blade solution, while Conventional Blades use a durable framed design for everyday reliability.",
      "Before supplying, always confirm the correct blade size, series, fitting type and DENSO part number using the latest DENSO Catalogue.",
      "There are 4 DENSO wiper blade series: DDP (Premium Design), DDS (Standard Design), DCP (Premium Conventional) and DCS (Standard Conventional).",
    ],
  },
];

export const TOTAL_MODULES = TRAINING_MODULES.length;
